import { ShimmerEffect } from "@/design-system/Atoms";
import { useCheckoutService } from "@/rtkQuery/features/hooks/useCheckoutService";
import { AppEmptyState, AppErrorState } from "@/design-system/Feedbacks";

const CheckoutConfirmationSection = () => {
  const {
    recentOrders,
    recentOrdersLoading,
    recentOrdersError,
    recentOrdersErrorMessage,
  } = useCheckoutService();

  if (recentOrdersError)
    return <AppErrorState message={recentOrdersErrorMessage} />;

  const orderDetails = recentOrders;
  const isValidOrder =
    orderDetails && typeof orderDetails === "object" && "Id" in orderDetails;

  return (
    <>
      <div className="form-bg bg-[#f6f7f9] mb-10 p-8 rounded-[20px] animate-fade-in">
        <h3 className="text-2xl mb-5 text-[#181a20]">Checkout Complete</h3>

        <div className="bg-white p-5 mb-6 rounded-lg">
          <h4 className="text-[1rem] font-bold text-[#3B4151]">Shipping</h4>
          <div className="flex flex-wrap gap-8">
            <p className="mb-0 text-[1.25rem] text-[#3B4151]">
              Expedited (5-7 Business Days)
            </p>
          </div>
        </div>

        <div
          className={` ${!isValidOrder ? "" : "bg-[#f6f7f9]"} p-[1.25rem] mb-6 rounded-[8px] w-full `}
        >
          {recentOrdersLoading ? (
            <>
              <ShimmerEffect className="h-[100px] w-full" />
            </>
          ) : !isValidOrder ? (
            <AppEmptyState message="No recent orders found." />
          ) : orderDetails && orderDetails ? (
            <div className="flex flex-wrap -mx-[0.75rem]">
              <div className="flex-[1_0_0%] px-[0.75rem] mb-4 md:mb-0">
                <p className="text-[1rem] font-bold text-[#3B4151]">Cost</p>
                <p className="mb-0 text-[1.25rem] text-[#3B4151]">
                  ${orderDetails?.TotalPaid?.toFixed(2)}
                </p>
              </div>

              <div className="flex-[1_0_0%] px-[0.75rem] mb-4 md:mb-0">
                <p className="text-[1rem] font-bold text-[#3B4151]">
                  Order Number
                </p>
                <p className="mb-0 text-[1.25rem] text-[#3B4151]">
                  {orderDetails?.MagentoOrderId}
                </p>
              </div>

              <div className="flex-[1_0_0%] px-[0.75rem] mb-4 md:mb-0">
                <p className="text-[1rem] font-bold  text-[#3B4151]">
                  Order Status
                </p>
                <p className="mb-0 text-[1.25rem] text-[#3B4151] capitalize">
                  {orderDetails?.Status || "N/A"}
                </p>
              </div>
            </div>
          ) : (
            <AppEmptyState message="No order details available." />
          )}
        </div>
      </div>
    </>
  );
};

export default CheckoutConfirmationSection;